module.exports = __webpack_public_path__ + "static/motion-simulation-dark-af129cb26813135090a5548954adea71.svg";